import httpService from "..";

// Pay@ Payment Type Definitions
export interface ResendPayAtSMSResponse {
  success: boolean;
  status: number;
  data: {
    memberId: number;
    accountNumber: string;
    cellphone: string;
  };
  message: string;
}

export interface RegeneratePayAtNumberRequest {
  confirmedBy: number;
  userConfirmed: boolean;
}

export interface RegeneratePayAtNumberResponse {
  success: boolean;
  status: number;
  data: {
    memberId: number;
    oldAccountNumber: string;
    newAccountNumber: string;
    cellphone: string;
    smsSent: boolean;
  };
  message: string;
}

export const getPaymentsApi = async () => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment`,
    "get"
  );
};

export const getPaymentApi = async (id: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/${id}`,
    "get"
  );
};

export const addPaymentApi = async (
  memberId: string,
  type: string,
  data: {}
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment?type=${type}&memberId=${memberId}`,
    "post",
    data
  );
};

/** Create Cash PaymentType (no mandate). Idempotent if already Cash. BUG-13 / P3-02. */
export const addCashPaymentTypeApi = async (memberId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/cash?memberId=${memberId}`,
    "post"
  );
};

export const addNutunDebiCheckPaymentApi = async (
  memberId: string,
  data: {}
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/nutun/debi-check-initiation?memberId=${memberId}`,
    "post",
    data
  );
};

export const addNupayDebiCheckPaymentApi = async (
  memberId: string,
  data: {}
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/nupay/debi-check-initiation?memberId=${memberId}`,
    "post",
    data
  );
};

export const addPayAtPaymentApi = async (memberId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/pay-at/initiation?memberId=${memberId}`,
    "post"
  );
};

export const addSecondaryPaymentApi = async (memberId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/secondary?memberId=${memberId}`,
    "post"
  );
};

export const resendPayAtSmsApi = async (memberId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/pay-at/resend-sms?memberId=${memberId}`,
    "post"
  );
};

export const regeneratePayAtNumberApi = async (
  memberId: string,
  data: RegeneratePayAtNumberRequest
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/pay-at/regenerate-number?memberId=${memberId}`,
    "post",
    data
  );
};

export const editDebiCheckPaymentApi = async (memberId: string, data: {}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/debi-check-update?memberId=${memberId}`,
    "put",
    data
  );
};

export const editPaymentApi = async (id: string, data: any) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/${id}`,
    "patch",
    data
  );
};

export const removeNupayDebiCheckPaymentApi = async (memberId: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/nupay/debi-check-cancellation?memberId=${memberId}`,
    "post",
    {}
  );
};

export const removePaymentApi = async (id: string) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/${id}`,
    "delete"
  );
};

export const addBulkPaymentApi = async (data: {
  groupId: string;
  totalAmount: number;
  paymentDate: string;
  paymentReference: string;
  paymentMethod: string;
  notes: string;
  allocations: Array<{ memberId: string; amount: number }>;
}) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/bulk`,
    "post",
    data
  );
};

// DebiCheck Maintenance APIs

export const debiCheckAmountAdjustmentApi = async (
  memberId: string,
  data: { Amount: number; Reason: string }
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/nupay/debi-check-maintenance/amount?memberId=${memberId}`,
    "post",
    data
  );
};

export const debiCheckCollectionDayChangeApi = async (
  memberId: string,
  data: { CollectionDay: number; Reason: string }
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/nupay/debi-check-maintenance/collection-day?memberId=${memberId}`,
    "post",
    data
  );
};

export const debiCheckAccountChangeApi = async (
  memberId: string,
  data: {
    AccountNumber: string;
    AccountType: string;
    Bank: string;
    BranchCode: string;
    Reason: string;
  }
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/nupay/debi-check-maintenance/account?memberId=${memberId}`,
    "post",
    data
  );
};

export const debiCheckSuspendMandateApi = async (
  memberId: string,
  data: { Reason: string }
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/nupay/debi-check-maintenance/suspend?memberId=${memberId}`,
    "post",
    data
  );
};

export const debiCheckReactivateMandateApi = async (
  memberId: string,
  data: { Reason: string }
) => {
  return await httpService(
    `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/payment/nupay/debi-check-maintenance/reactivate?memberId=${memberId}`,
    "post",
    data
  );
};
